import { comp as _comp } from "@thi.ng/compose";
export function comp() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return _comp.apply(null, fns);
}